import { useSyncExternalStore } from 'react';
import { getLocale, getT, getUnitSystem, subscribeLocale, type Locale, type Messages, type UnitSystem } from './index';
import { localeSettings, subscribeToLocaleSettings, type LocaleSettings } from './settings';

/** The active dictionary; re-renders on a language change. */
export function useT(): Messages {
  return useSyncExternalStore(subscribeLocale, getT, getT);
}

export function useLocale(): Locale {
  return useSyncExternalStore(subscribeLocale, getLocale, getLocale);
}

export function useUnitSystem(): UnitSystem {
  return useSyncExternalStore(subscribeLocale, getUnitSystem, getUnitSystem);
}

/** The raw preferences (with `auto`), for the settings screen. */
export function useLocaleSettings(): LocaleSettings {
  return useSyncExternalStore(subscribeToLocaleSettings, localeSettings, localeSettings);
}
